<template>
  <div class="flex flex-col">
    <div
      class="relative flex overflow-hidden rounded-[12px]"
      :class="[
        { 'size-full max-h-[400px] max-w-[400px] ': isLecture },

        { 'max-h-[675px]': !isLecture && !isTeacherTest },
      ]"
    >
      <div
        v-if="isSocial"
        class="absolute flex items-center text-[12px] text-white-100"
        :class="
          isNotDesktop ? 'left-[12px] top-[12px] ' : 'left-[24px] top-[20px] '
        "
      >
        <CommonSocialsSocialButtonsNew
          icon-only
          dark-border
          :data="data"
          is-mobile
          :buttons="['like', 'bookmark']"
        />
      </div>
      <slot name="teacher-button"></slot>
      <img
        v-lazy-load
        :src="imageSrc || '/imgs/default-image.png'"
        alt=""
        class="general-preview-image w-full object-cover"
      />
      <div
        v-if="publishedAt"
        class="absolute bottom-[20px] right-[24px] flex items-center rounded-[8px] bg-[#1F1F1F] px-[10px] py-[8px] text-[10px] leading-[9px] text-white-100 md:p-[18px] md:text-[12px] md:leading-[14px]"
      >
        <div class="mr-[8px] hidden size-[12px] bg-white-100 md:block" />
        {{ new Date(publishedAt).toLocaleDateString() }}
      </div>
    </div>
    <div
      v-if="data?.image?.alt || data?.image?.text_source"
      class="mb-4 mt-2 flex flex-wrap justify-between empty:m-0"
    >
      <span class="text-smaller" style="font-weight: bold">{{
        data?.image?.alt
      }}</span>
      <span class="text-smaller">{{ data?.image?.text_source }}</span>
    </div>
  </div>
</template>

<script setup>
const { isNotDesktop } = useBreakpoint();
const props = defineProps({
  src: {
    type: String,
    required: true,
  },

  publishedAt: {
    type: String,
    default: '',
  },

  isSocial: {
    type: Boolean,
    default: false,
  },

  isLecture: {
    type: Boolean,
    default: false,
  },

  isTeacherTest: {
    type: Boolean,
    default: false,
  },

  data: {
    type: Object,
    default: () => ({}),
  },
});

const imageSrc = computed(() => props.src);
</script>

<style lang="scss">
.test-cardimage .general-preview-image {
  aspect-ratio: 16/9;
}
</style>
